
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/import",
      function () {
        return require("private-next-pages/customers/import.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/import"])
      });
    }
  